import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { getEditingValue, setEdittingMap } from '../../store';
import { EType } from '../../type';
import { RightOutlined } from '@ant-design/icons';
import _ from 'lodash';
import css from './css.less';
import Tooltip from 'src/components/GlobalTooltip/GlobalTooltip';
const Stock = (props) => {
  const { stock, type, value } = props;
  const _v = React.useMemo(() => {
    if (type) {
      if (_.isNumber(value)) {
        if (type === EType.Add && value > 0) {
          return (
            <div className={css.container}>
              {stock}
              <RightOutlined />
              <span className={css.text}>{value + stock}</span>
            </div>
          );
        }
        if (type === EType.Add && value < 0) {
          return (
            <div className={css.container}>
              {stock}
              <RightOutlined />
              <span className={css.decreaseText}>{value + stock}</span>
            </div>
          );
        }
        if (type === EType.Set) {
          return (
            <div className={css.container}>
              {stock}
              <RightOutlined />
              <span className={css.text}>{value}</span>
            </div>
          );
        }
        return stock;
      } else {
        return stock;
      }
    } else {
      return stock;
    }
  }, [value, type, stock]);
  return <Tooltip title={_v}>{_v}</Tooltip>;
};
export default Stock;
